<span class="notification-toggle" data-testid="notif-toggle" [askSpinner]="isLoadingUserDevice" spinnerSize="small"
  spinnerColor="var(--asksuite-orange)">

  @if (!isIOS) {
    <ng-container *ngTemplateOutlet="desktopOptions"></ng-container>
  }
  @else {
    <ng-container *ngTemplateOutlet="iOSOptions"></ng-container>
  }
</span>

<ng-template #iOSOptions>
  @if (!notificationPermission) {
    <ask-button-v2
      appearance="transparent"
      data-testid="notification-btn" 
      appearance="transparent"
      [disabled]="isLoadingUserDevice"
      [askDropdown]="isStandalone ? notificationIOSApp : notificationIOSBrowser"
      [selected]="isSomeDropdownOpen"
    >
      <app-icon name="notifications_off" data-testid="notification-icon"/>
    </ask-button-v2>
  }
  @else {
    <ask-button-v2
      appearance="transparent"
      data-testid="notification-btn"
      [disabled]="isLoadingUserDevice"
      [askDropdown]="notificationGrantedOptions"
      [dropdownDisabled]="isLoadingUserDevice" 
      askTooltip 
      [askTooltipMessage]="'TOOLTIPS.NOTIFICATIONS' | translate"
      [selected]="isSomeDropdownOpen"
    >
      <app-icon [name]="notificationIcon" data-testid="notification-icon"/>
    </ask-button-v2>
  }
</ng-template>

<ng-template #desktopOptions>
  @if (!notificationRegisterError) {
    <ask-button-v2
      appearance="transparent"
      data-testid="notification-btn"
      [disabled]="isLoadingUserDevice"
      [askDropdown]="notificationPermission ? notificationGrantedOptions : notificationDeniedOptions"
      [dropdownDisabled]="isLoadingUserDevice" 
      askTooltip 
      [askTooltipMessage]="'TOOLTIPS.NOTIFICATIONS' | translate"
      [selected]="isSomeDropdownOpen"
    >
        <app-icon [name]="notificationIcon" data-testid="notification-icon"/>
    </ask-button-v2>

  }
  @else {
    <ask-button-v2
      appearance="transparent"
      data-testid="notification-btn"
      [askDropdown]="notificationRegisterErrorOptions"
      [dropdownDisabled]="isLoadingUserDevice" 
      askTooltip 
      [askTooltipMessage]="'TOOLTIPS.NOTIFICATIONS' | translate"
      [selected]="isSomeDropdownOpen"
    >
        <app-icon [name]="notificationIcon" data-testid="notification-icon"/>
    </ask-button-v2>

  }
</ng-template>

<ng-template #notificationGrantedOptions>
  <div class="dropdown-notification" data-testid="dropdown-notification-enabled">
    <div class="dropdown-info">
      <p class="title" data-testid="notif-active-title">{{ (!userDeviceStatus ? "NOTIFICATION.DISABLED" :
        "NOTIFICATION.ACTIVATED") | translate }}</p>
  
      <p class="text" data-testid="notif-config-info" *ngIf="userDeviceStatus">{{ "NOTIFICATION.TEXT_CONFIGURE" | translate }}</p>
    </div>
    
    <div class="action">
      <button 
        *ngIf="!userDeviceStatus; else configureAction"
        class="notification-button"
        (click)="enableNotifications()"
        data-testid="notif-action-enable"
        askButton color="primary" size="small"
      >
        {{ "ACTIVE" | translate }}
      </button>
      <ng-template #configureAction>
        <button 
          class="notification-button"
          (click)="configureNotifications()"
          data-testid="notif-action-config"
          askButton color="primary" size="small"
          >
            {{ "TOOLTIPS.NOTIFICATIONS" | translate }}
        </button>
      </ng-template>
    </div>
    <div class="horizontal-line"></div>

    <ng-container *ngIf="!userDeviceStatus; else notificationActive">
      <p class="text" data-testid="notif-info">{{ "NOTIFICATION.TEXT" | translate }}</p>
      <img src="assets/img/notification.svg" class="image" data-testid="notif-img" />
    </ng-container>

    <ng-template #notificationActive>
      <div class="action">
        <button class="notification-button" (click)="disableNotifications()" data-testid="notif-action-disable" askButton color="secondary" size="small">
          {{ "DESACTIVE" | translate }}
        </button>
      </div>
    </ng-template>
  </div>  
</ng-template>

<ng-template #notificationDeniedOptions>
  <div class="dropdown-notification" data-testid="dropdown-notification-disabled">
    <div class="dropdown-info">
      <p class="title">{{ "NOTIFICATION.BLOCKED" | translate }}</p>
      <p class="text">{{ "NOTIFICATION.BLOCKED_BY_BROWSER" | translate }}</p>
    </div>
    <button class="notification-button" [disabled]="true" data-testid="notif-action-enable" askButton color="primary" size="small">
      {{ 'ACTIVE' | translate }}
    </button>
    <div class="horizontal-line"></div>
    <p class="text" [innerHTML]="'NOTIFICATION.TEXT_BLOCKED_BY_BROWSER' | translate"></p>
  </div>
</ng-template>

<ng-template #notificationRegisterErrorOptions>
  <div class="dropdown-notification" data-testid="dropdown-notification-error">
    <div class="dropdown-info">
      <p class="title">{{ "NOTIFICATION.DISABLED" | translate }}</p>
      <p class="text">{{ "NOTIFICATION.ACTIVATION_ERROR" | translate }}</p>
    </div>
    <button class="notification-button" data-testid="notif-action-reload" (click)="reloadPage()" askButton color="primary" size="small">
      {{ "RELOAD_PAGE" | translate }}
    </button>
    <div class="horizontal-line"></div>
    <p class="text" [innerHTML]="'NOTIFICATION.TEXT_ACTIVATION_ERROR' | translate"></p>
  </div>
</ng-template>

<ng-template #notificationIOSApp>
  <div class="dropdown-notification" data-testid="dropdown-ios-app">
    <div class="dropdown-info">
      <p class="title" data-testid="notif-ios-app-title">{{ 'NOTIFICATION.IOS_PERMISSION_REQUIRED' | translate }}</p>
  
      <p class="text" data-testid="notif-ios-app-info" >{{ 'NOTIFICATION.TEXT_IOS_PERMISSION_REQUIRED' | translate }}</p>
    </div>
    
    <div class="action">
      <button 
        class="notification-button"
        data-testid="notif-ios-app-action"
        askButton color="primary" size="small"
        (click)="requestPermission()"
      >
        {{ 'NOTIFICATION.IOS_ALLOW_NOTIFICATION' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #notificationIOSBrowser>
  <div class="dropdown-notification" data-testid="dropdown-ios-browser">
    <div class="dropdown-info">
      <p class="title" data-testid="notif-ios-browser-title">{{ 'NOTIFICATION.IOS_NOTIFICATION_PERMISSION' | translate }}</p>
  
      <p class="text" data-testid="notif-ios-browser-info" >{{ 'NOTIFICATION.TEXT_IOS_NOTIFICATION_PERMISSION' | translate }}</p>
    </div>
    
    <div class="action">
      <a class="notification-link" [href]="'HELP_CENTER_URL_MOBILE' | translate" target="_blank">
        <button 
          class="notification-button"
          data-testid="notif-ios-browser-action"
          askButton color="primary" size="small"
        >
          {{ 'LEARN_MORE' | translate }}
        </button>
      </a>
    </div>
  </div>
</ng-template>